import styles from "./index.module.css";
import { useState } from "react";

const items = [
  {
    title: "Скільки це займе мого часу?",
    text: "З понеділка по четвер, кожного тижня. 52 уроки за три місяці",
  },
  {
    title: "А якщо з нуля?",
    text: "Якщо ви починаєте з нуля, радимо обрати рівень A1-A2 - саме тут викладачі допоможуть вам опанувати базову граматику та лексику з самого початку",
  },
  {
    title: "Що, якщо я не встигну?",
    text: "Твій прогрес залежить від регулярного відвідування, активної участі й виконання завдань. Якщо ти не встигнеш засвоїти матеріал у повному обсязі, викладач підтримає тебе у подальшому навчанні та допоможе завершити рівень",
  },
  {
    title: "Чи можна оплатити частинами?",
    text: "Оплата проводиться у вигляді абонемента за весь інтенсив, або з можливістю поділити оплату на дві частини. Оплата має бути здійснена в повному обсязі до початку курса, без можливості повернення",
  },
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className={styles.section} id={"faq"} data-aos={"fade-up"}>
      <div className={styles.container}>
        <h2>Поширені питання</h2>
        <div className={styles.list}>
          {items.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                className={
                  isActive
                    ? styles.item + " " + styles.itemActive
                    : styles.item
                }
                key={item.title}
              >
                <button
                  aria-expanded={isActive}
                  className={styles.trigger}
                  onClick={() => setActiveIndex(isActive ? -1 : index)}
                  type="button"
                >
                  <span>{item.title}</span>
                  <span className={styles.icon} aria-hidden="true" />
                </button>
                <div className={styles.answer}>
                  <p>{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
